import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.COMPLAINT_EDIT_SUCCESS, complaint: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.COMPLAINT_EDIT_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const complaintEdit = (data, complaintId) => {
  return async (dispatch) => {
    dispatch({ type: CONST.COMPLAINT_EDIT_REQUEST });

    return axios.put(`/tickets/${complaintId}`, data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
